<svg-icon src="/assets/img/icons/{{ icon() }}.svg" />
